export const columnsDataDevelopment = ["ID", "TITLE", "DESCRIPTION", "ACTION"];
